import { useContext, useRef } from "react";
import useLogout from "./useLogout";
import constants from "../constants";
import AlertContext from "../context/AlertContext";
import InstructionPageHooks from "./InstructionPage/InstructionPageHooks";

export default function useCommonFunctionHooks() {
  const Alert = useContext(AlertContext);

  // const InstructionPageHks = InstructionPageHooks();

  const logout = useLogout();
  const picRef = useRef(null);

  const sidebarElement = document.querySelector(
    'chatgpt-sidebar[data-gpts-theme="light"]'
  );

  if (sidebarElement) {
    sidebarElement.style.display = "none";
  }

  const handleWebCamError = () => {
    let testData2 = Alert.testData;

    if (Alert.testData.mockuse) {
      testData2.proctored = constants.PROCTORING_MODE.TAB;
      Alert.setTestData(testData2);
    }

    Alert.setCamAvailable(false);
  };

  const handleClose = (from) => {
    Alert.setShowNotify({ show: false });
  };

  const handleNavigate = () => {
    if (Alert.testData.ainterview) {
      Alert.navigate("main/interview/results");
      //closure issue in submit scenario so reseting to initial state
      Alert.setTestDetail({});
      Alert.updateComingObj({});
      Alert.setTimeComplexityResult(null);
      // window.location.reload();
    } else if (Alert.testData.mockuse) {
      console.log("testdata : ",Alert.testData);
      if(Alert.testData.scope=="COMPANY") Alert.navigate("main/company_specific/results");
      else if(Alert.testData.scope=="TECH") Alert.navigate("main/technology_specific/results");
      else Alert.navigate("main/mock/results");
      //closure issue in submit scenario so reseting to initial state
      Alert.setTestDetail({});
      Alert.updateComingObj({});
    } else {
      Alert.navigate("/home");
      //closure issue in submit scenario so reseting to initial state
      Alert.setStatus("");
    }
  };

  const checkBatchType = () => {
    return (
      parseInt(localStorage.getItem("batchType")) ===
      constants.BATCH_TYPE.TESTING
    );
  };

  const formatTime = (seconds) => {
    const secs = seconds % 60;
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);

    const formattedMins = `${mins}`.padStart(2, "0");
    const formattedSecs = `${secs}`.padStart(2, "0");
    const formattedHrs = hrs > 0 ? `${hrs}`.padStart(2, "0") : null;

    if (formattedHrs) {
      return ` ${formattedHrs} : ${formattedMins} : ${formattedSecs}`;
    } else {
      return ` ${formattedMins} : ${formattedSecs}`;
    }
  };

  const formatDuration = (minutes) => {
    if (!minutes || minutes <= 0) return;

    const days = Math.floor(minutes / (24 * 60));
    const hours = Math.floor((minutes % (24 * 60)) / 60);
    const remainingMinutes = minutes % 60;

    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (remainingMinutes > 0) parts.push(`${remainingMinutes}m`);

    return parts.join(" ");
  };

  const handleFirstLogin = () => {
    Alert.setShowNotify({
      show: true,
      titleSvg: "info",
      msg: "In our effort to improve the user experience, our LMS platform got a new look. Please raise an issue if you face any difficulty.",
      primaryButtonFunction: () => {
        Alert.setShowNotify({ show: false });
      },
    });
  };

  const handleRegistration = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }

    Alert.setLpData({});
    Alert.setShowNotify({ show: false });
    Alert.navigate("/registration");
  };

  const handleUnAuthAlert = async () => {
    Alert.setAuth({});
    try {
      await logout();
    } catch (err) {
    } finally {
      Alert.setIsUnAuth(false);
      Alert.setIsBatchDetails(false);
      Alert.setShowNotify({ show: false });
      localStorage.removeItem("tokenKey");
      localStorage.removeItem("refreshToken");
      Alert.navigate("/");
      // window.location.reload();
    }
  };

  const getHeaderDetailsForAxios = (file) => {
    return {
      timeout: 60000,
      headers: {
        "Content-Type":
          file === "multipart" ? "multipart/form-data" : " application/json",
      },
    };
  };

  const handleLogOut =()=>{
    handleClose();
  }

  const getCatchBlockDetails = (error, component) => {
    console.log(error);

    Alert.setIsLoaded(false);

    if (error.message === "timeout of 60000ms exceeded") {
      Alert.setShowNotify({
        show: true,
        title: "Error",
        msg: "Something went wrong. Please try again.",
      });
    } else if (error.message.includes("403")) {
      Alert.setShowNotify({
        show: true,
        title: "Warning !",
        isUnAuth: true,
        msg: "You have been logged-out due to inactivity. Login again.",
        // primaryButtonFunction: handleLogOut,
      });
    } else if (
      component === "proctor" &&
      error.message === "Cannot read properties of undefined (reading 'length')"
    ) {
      Alert.setShowNotify({
        show: false,
      });
    } else if (
      error?.response?.status === 401 ||
      error.message?.includes("401")
    ) {
      Alert.setShowNotify({
        show: true,
        title: "Session Expired",
        isUnAuth: true,
        msg: "Your session has expired or you are unauthorized. Please login again.",
       
      });
    }

    else {
      Alert.setShowNotify({
        show: true,
        msg: error.message,
        title: error.title ? error.title : "Error",
      });
    }
  };

  return {
    picRef,
    formatTime,
    handleClose,
    handleNavigate,
    checkBatchType,
    formatDuration,
    handleFirstLogin,
    handleUnAuthAlert,
    handleWebCamError,
    handleRegistration,
    getCatchBlockDetails,
    getHeaderDetailsForAxios,
  };
}
